import { render } from "./ModalAgregarEntradaLegislacion.vue?vue&type=template&id=0f1146c2&scoped=true"
import script from "./ModalAgregarEntradaLegislacion.vue?vue&type=script&lang=js"
export * from "./ModalAgregarEntradaLegislacion.vue?vue&type=script&lang=js"

import "@/assets/styles/modal-styles.css?vue&type=style&index=0&id=0f1146c2&scoped=true&lang=css"
import "./ModalAgregarEntradaLegislacion.vue?vue&type=style&index=1&id=0f1146c2&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1146c2"]])

export default __exports__